module.exports = __webpack_public_path__ + "img/Frustracion.1103ce0a.svg";